import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const ExportTranscriptContent = ({ content, onChange }) => {
  const handleEmailChange = email => {
    onChange({ email });
  };

  return (
    <Flex center fat="true" xSpace>
      <Span noWrap>and email to</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Email"
          placeholder="Email"
          value={content.email}
          onChange={handleEmailChange}
        />
      </Flex>
    </Flex>
  );
};

ExportTranscriptContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    email: PropTypes.string.isRequired
  }).isRequired
};

export default ExportTranscriptContent;
